import { render, staticRenderFns } from "./AudioPlayerWithSubtitles.vue?vue&type=template&id=20a6b75c&scoped=true&"
import script from "./AudioPlayerWithSubtitles.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayerWithSubtitles.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayerWithSubtitles.vue?vue&type=style&index=0&id=20a6b75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6b75c",
  null
  
)

export default component.exports